import { useContext } from 'react';
import { StoreContext } from '@roc/feature-app-core';
import { AppraisalsStore } from '../stores';

export const useAppraisalsStore = () => useContext<{
  appraisalsStore: AppraisalsStore
}>(StoreContext);
